
import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useStableNavigate } from "context/StableNavigateContext";

const NoProfilesSelected = () => {
  const navigate = useStableNavigate();

  return (
    <MDBox pt={6} pb={6}>
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12}>
          <Card>
            <MDBox textAlign="center" p={4}>
              <MDTypography variant="h1" sx={{ fontWeight: 400 }} gutterBottom>
                How to get started
              </MDTypography>

              <Grid container spacing={4} justifyContent="center">
                {/* Step 1 */}
                <Grid item xs={12} md={4} textAlign="center">
                  <MDTypography variant="h1" sx={{ fontWeight: 400 }}>1</MDTypography>
                  <MDTypography variant="h3" sx={{ fontWeight: 400 }} gutterBottom>
                    Add your profile
                  </MDTypography>
                  <Typography variant="body2" color="textSecondary">
                    Connect your social media profile using the Dashboard.
                  </Typography>
                  <MDBox mt={3}>
                    <MDButton
                      variant="contained"
                      color="accent"
                      onClick={() => navigate("/dashboard")}
                    >
                      Go to Dashboard
                    </MDButton>
                  </MDBox>
                </Grid>

                {/* Step 2 */}
                <Grid item xs={12} md={4} textAlign="center">
                  <MDTypography variant="h1" sx={{ fontWeight: 400 }}>2</MDTypography>
                  <MDTypography variant="h3" sx={{ fontWeight: 400 }} gutterBottom>
                    Add competitor profile
                  </MDTypography>
                  <Typography variant="body2" color="textSecondary">
                    Add competitor profiles using Platform Scout.
                  </Typography>
                  <MDBox mt={3}>
                    <MDButton
                      variant="contained"
                      color="accent"
                      onClick={() => navigate("/platform-scout")}
                    >
                      Go to Platform Scout
                    </MDButton>
                  </MDBox>
                </Grid>

                {/* Step 3 */}
                <Grid item xs={12} md={4} textAlign="center">
                  <MDTypography variant="h1" sx={{ fontWeight: 400 }}>3</MDTypography>
                  <MDTypography variant="h3" sx={{ fontWeight: 400 }} gutterBottom>
                    Analyse profiles
                  </MDTypography>
                  <Typography variant="body2" color="textSecondary">
                    Select and analyse profiles using Social Stash.
                  </Typography>
                  <MDBox mt={3}>
                    <MDButton
                      variant="contained"
                      color="accent"
                      onClick={() => navigate("/social-stash")}
                    >
                      Go to Social Stash
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default NoProfilesSelected;
